module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kg-Lb.1ed13eb4.png";